import banner from 'assets/images/distributionPage/Promotional/banner.png'
import stopper from 'assets/images/distributionPage/Promotional/stopper.png'
import boxes from 'assets/images/distributionPage/Promotional/boxes.png'
import deskwindow from 'assets/images/distributionPage/Promotional/A3_deskwindow.png'
import cards from 'assets/images/distributionPage/Promotional/cards.png'
import paper from 'assets/images/distributionPage/Promotional/A5_paper.png'
import poster from 'assets/images/distributionPage/Promotional/A3_poster.png'
import ribbon from 'assets/images/distributionPage/Promotional/stripe_ribbon.png'
import corner from 'assets/images/distributionPage/Promotional/tablet_corner.png'
import covers from 'assets/images/distributionPage/Promotional/covers.png'

export const promotionalMaterialsItems = [
  {
    src: banner,
    title: 'Баннеры',
  },
  {
    src: stopper,
    title: 'Стопперы',
  },
  {
    src: boxes,
    title: 'Домики',
  },
  {
    src: deskwindow,
    title: 'А3\nДесквиндоу',
  },
  {
    src: cards,
    title: 'Карточки\nподписок',
  },
  {
    src: paper,
    title: 'А5\nЛистовка',
  },
  {
    src: poster,
    title: 'Плакаты',
  },
  {
    src: ribbon,
    title: 'Страйп-лента',
  },
  {
    src: corner,
    title: 'Уголок на\nпланшет',
  },
  {
    src: covers,
    title: 'Шуберы',
  },
]
